<!-- 指引页面 -->
<template>
  <div class='guide_page'>
    <div class="guide_body">
      <div class="guide_title">请使用手机扫描下方二维码访问本页面</div>
      <div class="guide_qrcode_wrap">
        <vueQr
          class="guide_qrcode"
          :text="url"
          :size="qrcode.size"
          :margin="qrcode.margin"
          :dotScale="qrcode.dotScale"
        />
      </div>
    </div>
  </div>
</template>

<script>
import vueQr from 'vue-qr'
import apiObj from '@a/js/api.js'
export default {
  name: 'Guide',
  data() {
    return {
      url: 'link',
      qrcode: {
        size: 260,
        margin: 15,
        dotScale: 0.8
      },
      params: {}
    };
  },

  components: {
    vueQr
  },

  methods: {
    // 获取参数信息
    GetParamsData() {
      return new Promise(resolve => {
        this.params = this.$route.params;
        resolve();
      });
    },
    // 初始化二维码链接
    initQrcodeUrl() {
      let link = apiObj.VUE_APP_BASE_SERVE + 'ticket/ticket/' + this.params.accountid + '/' + this.params.projectid
      this.url = link
      console.log(this.url)
    }
  },

  mounted() {
    this.GetParamsData().then(() => {
      this.initQrcodeUrl()
    })
  },
}
</script>
<style lang='less' scoped>
.guide_page {
  overflow: hidden;
  .guide_body {
    .guide_title {
      margin-top: 120px;
      font-size: 16px;
      letter-spacing: 2px;
      text-align: center;
    }
    .guide_qrcode_wrap {
      margin-top: 50px;
      text-align: center;
    }
  }
}
</style>

<style lang="less" >
// @media screen and (min-width: 1100px) {
//   html {
//     width: 375px !important;
//     font-size: 37.5px !important;
//     margin: 30px auto 0 !important;
//     background: #ebedf0 !important;
//     .guide_page {
//       width: 375px !important;
//       height: 667px !important;
//       overflow: hidden;
//     }
//   }
// }
//
</style>